{
    "columns": [
      {
        "header_id": "timeSheetLineDetailId",
        "header_label": "Timesheet ID",
        "jsonpath": "timeSheetLineDetailId",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "providerPplId",
        "header_label": "Provider PPL ID",
        "jsonpath": "providerPplId",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "providerName",
        "header_label": "Provider Name",
        "jsonpath": "providerName",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "serviceDate",
        "header_label": "Service Date",
        "jsonpath": "serviceDate",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "usedUnits",
        "header_label": "Spent Dollars",
        "jsonpath": "usedUnits",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "usedUnitsHrs",
        "header_label": "Hours Worked",
        "jsonpath": "usedUnitsHrs",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      }
    ],
    "buttons": [],
    "apiDetails": "authTimesheetsList.json",
    "pageName": "addAuthorizationsList",
    "orderByColumn": ["timeSheetLineDetailId"],
    "orderBy": ["desc"]
  }
  